/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { PageInfoFragmentDoc } from '../pageInfo/pageInfo.g';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ApplicationResourceFragment = { __typename: 'ApplicationResourceType', id: string, createdAt: string, updatedAt: string, vendorName?: string | null, productName?: string | null, vendorDomainName?: string | null, productDomainName?: string | null, vendorDescription?: string | null, productDescription?: string | null, key?: string | null, enrichedAt?: string | null, isVisible: boolean, nonPrimaryResourcesCount?: number | null, publicResource: { __typename: 'ResourceType', id: string, signedLogoUrl?: string | null, isVisible: boolean, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null }, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string, isMspModified: boolean } | null };

export type ApplicationResourceQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type ApplicationResourceQuery = { __typename: 'Query', applicationResource?: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, vendorName?: string | null } | null };

export type ApplicationResourcesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  vendorName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productDomainName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  vendorDomainName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  key?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isPrimaryResource?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isSaas?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isVisible?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  parentCategoryId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ApplicationResourcesQuery = { __typename: 'Query', applicationResources?: { __typename: 'ApplicationResourceTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ApplicationResourceTypeEdge', node?: { __typename: 'ApplicationResourceType', id: string, createdAt: string, updatedAt: string, vendorName?: string | null, productName?: string | null, vendorDomainName?: string | null, productDomainName?: string | null, vendorDescription?: string | null, productDescription?: string | null, key?: string | null, enrichedAt?: string | null, isVisible: boolean, nonPrimaryResourcesCount?: number | null, publicResource: { __typename: 'ResourceType', id: string, signedLogoUrl?: string | null, isVisible: boolean, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null }, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string, isMspModified: boolean } | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const ApplicationResourceFragmentDoc = `
    fragment ApplicationResource on ApplicationResourceType {
  id
  createdAt
  updatedAt
  vendorName
  productName
  vendorDomainName
  productDomainName
  vendorDescription
  productDescription
  key
  enrichedAt
  isVisible
  nonPrimaryResourcesCount
  publicResource {
    id
    signedLogoUrl
    isVisible
    category {
      id
      name
      parent {
        id
        name
      }
    }
  }
  resourceGroup {
    id
    isMspModified
  }
}
    `;
export const ApplicationResourceDocument = `
    query ApplicationResource($id: UUID!) {
  applicationResource(id: $id) {
    id
    productName
    vendorName
  }
}
    `;

export const useApplicationResourceQuery = <
      TData = ApplicationResourceQuery,
      TError = unknown
    >(
      variables: ApplicationResourceQueryVariables,
      options?: Omit<UseQueryOptions<ApplicationResourceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApplicationResourceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApplicationResourceQuery, TError, TData>(
      {
    queryKey: ['ApplicationResource', variables],
    queryFn: fetcher<ApplicationResourceQuery, ApplicationResourceQueryVariables>(ApplicationResourceDocument, variables),
    ...options
  }
    )};

useApplicationResourceQuery.getKey = (variables: ApplicationResourceQueryVariables) => ['ApplicationResource', variables];

export const useInfiniteApplicationResourceQuery = <
      TData = InfiniteData<ApplicationResourceQuery>,
      TError = unknown
    >(
      variables: ApplicationResourceQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApplicationResourceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApplicationResourceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApplicationResourceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ApplicationResource.infinite', variables],
      queryFn: (metaData) => fetcher<ApplicationResourceQuery, ApplicationResourceQueryVariables>(ApplicationResourceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteApplicationResourceQuery.getKey = (variables: ApplicationResourceQueryVariables) => ['ApplicationResource.infinite', variables];


useApplicationResourceQuery.fetcher = (variables: ApplicationResourceQueryVariables) => fetcher<ApplicationResourceQuery, ApplicationResourceQueryVariables>(ApplicationResourceDocument, variables);

export const ApplicationResourcesDocument = `
    query ApplicationResources($after: String, $before: String, $first: Int, $last: Int, $offset: Int, $search: String, $vendorName_Icontains: String, $productName_Icontains: String, $productDomainName_Icontains: String, $vendorDomainName_Icontains: String, $key: String, $isPrimaryResource: Boolean, $isSaas: Boolean, $isVisible: Boolean, $parentCategoryId: UUID, $orderBy: String) {
  applicationResources(
    after: $after
    before: $before
    first: $first
    last: $last
    offset: $offset
    search: $search
    vendorName_Icontains: $vendorName_Icontains
    productName_Icontains: $productName_Icontains
    productDomainName_Icontains: $productDomainName_Icontains
    vendorDomainName_Icontains: $vendorDomainName_Icontains
    key: $key
    isPrimaryResource: $isPrimaryResource
    isSaas: $isSaas
    isVisible: $isVisible
    parentCategoryId: $parentCategoryId
    orderBy: $orderBy
  ) {
    edges {
      node {
        ...ApplicationResource
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    ${ApplicationResourceFragmentDoc}
${PageInfoFragmentDoc}`;

export const useApplicationResourcesQuery = <
      TData = ApplicationResourcesQuery,
      TError = unknown
    >(
      variables?: ApplicationResourcesQueryVariables,
      options?: Omit<UseQueryOptions<ApplicationResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApplicationResourcesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApplicationResourcesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ApplicationResources'] : ['ApplicationResources', variables],
    queryFn: fetcher<ApplicationResourcesQuery, ApplicationResourcesQueryVariables>(ApplicationResourcesDocument, variables),
    ...options
  }
    )};

useApplicationResourcesQuery.getKey = (variables?: ApplicationResourcesQueryVariables) => variables === undefined ? ['ApplicationResources'] : ['ApplicationResources', variables];

export const useInfiniteApplicationResourcesQuery = <
      TData = InfiniteData<ApplicationResourcesQuery>,
      TError = unknown
    >(
      variables: ApplicationResourcesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApplicationResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApplicationResourcesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApplicationResourcesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ApplicationResources.infinite'] : ['ApplicationResources.infinite', variables],
      queryFn: (metaData) => fetcher<ApplicationResourcesQuery, ApplicationResourcesQueryVariables>(ApplicationResourcesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteApplicationResourcesQuery.getKey = (variables?: ApplicationResourcesQueryVariables) => variables === undefined ? ['ApplicationResources.infinite'] : ['ApplicationResources.infinite', variables];


useApplicationResourcesQuery.fetcher = (variables?: ApplicationResourcesQueryVariables) => fetcher<ApplicationResourcesQuery, ApplicationResourcesQueryVariables>(ApplicationResourcesDocument, variables);
